// Human-readable sizes. Whole numbers up to MB ("184 MB"), one decimal from GB
// up with a trailing .0 dropped ("4.6 GB", "5 GB").
export function formatBytes(n: number) {
  if (!Number.isFinite(n) || n <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let v = n;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i += 1;
  }
  if (i < 3) return `${Math.round(v)} ${units[i]}`;
  const r = Math.round(v * 10) / 10;
  return `${Number.isInteger(r) ? r : r.toFixed(1)} ${units[i]}`;
}
